import React, { useState } from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  FormControlLabel,
  Checkbox,
  Link,
  Grid,
  Typography,
  makeStyles,
  Container,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import * as Yup from "yup";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { postLoginRequest, postUserLogin } from "../redux/actions/loginAction";
import SEO from "./SEO";
import Auth from '../routes/Auth'
import ParticlesBg from 'particles-bg'
import Logo from '../img/xapiens-logo.png'
import { Image } from "react-bootstrap";

const formValidationSchema = Yup.object({
  email: Yup.string("Enter your email address")
    .email("Enter a valid email address")
    .required("Email address is required"),
  password: Yup.string("")
    .min(8, "Password at least 8 characters")
    .required("Password is required"),
});

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(7),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    padding: "20px 80px"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    // marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Login = ({ postUserLogin, email, password, isAuthenticated, postLoginRequest }) => {
  const classes = useStyles();
  const history = useHistory();

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  let config = {
    num: [4, 7],
    rps: 0.1,
    radius: [5, 40],
    life: [1.5, 3],
    v: [2, 3],
    tha: [-40, 40],
    alpha: [0.6, 0],
    scale: [.1, 0.4],
    position: "all",
    color: ["random", "#ff0000"],
    cross: "dead",
    // emitter: "follow",
    random: 15
  };

  if (Math.random() > 0.85) {
    config = Object.assign(config, {
      onParticleUpdate: (ctx, particle) => {
        ctx.beginPath();
        ctx.rect(
          particle.p.x,
          particle.p.y,
          particle.radius * 2,
          particle.radius * 2
        );
        ctx.fillStyle = particle.color;
        ctx.fill();
        ctx.closePath();
      }
    });
  }
  

  return (
    <Container component="main" maxWidth="sm" className="d-flex justify-content-center align-items-center">
      <SEO
        title={document.title}
        description="Login Page"
        content="Login Page"
      />
      <ParticlesBg type="cobweb" config={config} bg={true} />
      <CssBaseline />

      <div className={classes.paper}>
        {/* <Avatar className={classes.avatar}> */}
          {/* <LockOutlinedIcon /> */}
          <Image src={Logo} rounded />
        {/* </Avatar> */}
        {/* <Typography component="h1" variant="h5">
          Sign in
        </Typography> */}
      {/* <h1 className="text-center mt-3" id="login-title">T-MANAGE</h1> */}
        <Formik
          initialValues={{ email, password }}
          validationSchema={formValidationSchema}
          onSubmit={({ email, password }) => {
            postUserLogin(email, password);
            postLoginRequest(true);
            Auth.login(() => {
              history.push("./dashboard");
            });
          }}
          className={classes.form}
          noValidate
        >
          {(props) => {
            const {
              values,
              touched,
              errors,
              handleChange,
              handleSubmit,
            } = props;

            return (
              <form onSubmit={handleSubmit}>
                <TextField
                  value={values.email}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                />
                {errors.email && touched.email && (
                  <div className="error__message">{errors.email}</div>
                )}
                <TextField
                  value={values.password}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  autoComplete="current-password"
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {errors.password && touched.password && (
                  <div className="error__message">{errors.password}</div>
                )}
                <FormControlLabel
                  control={<Checkbox value="remember" color="primary" />}
                  label="Remember me"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Sign In
                </Button>
                <Grid className="mt-2"container>
                  <Grid item xs>
                    <Link href="#" variant="body2">
                      Forgot password?
                    </Link>
                  </Grid>
                </Grid>
              </form>
            );
          }}
        </Formik>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    email: state.login.email,
    password: state.login.password,
    isAuthenticated: state.login.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    postUserLogin: (email, password) =>
      dispatch(postUserLogin(email, password)),
    postLoginRequest: (setAuth) => dispatch(postLoginRequest(setAuth)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
